import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getCupScoresLocale } from '../data/cupScoresLocale';
import { CUP_ADMIN_PASSWORD, CUP_ADMIN_SESSION_KEY } from '../config/cupAdmin';
import CupScores from './CupScores';
import './CupScores.css';
import './CupDataAdmin.css';

const CupDataAdmin: React.FC = () => {
  const { language } = useLanguage();
  const L = useMemo(() => getCupScoresLocale(language), [language]);
  const [authed, setAuthed] = useState(() => {
    try {
      return sessionStorage.getItem(CUP_ADMIN_SESSION_KEY) === '1';
    } catch {
      return false;
    }
  });
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (authed) return;
    document.title = L.documentTitleAdminGate;
    return () => {
      document.title = 'FK Junior Petrovaradin';
    };
  }, [authed, L.documentTitleAdminGate]);

  const onSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (password.trim() === CUP_ADMIN_PASSWORD.trim()) {
        try {
          sessionStorage.setItem(CUP_ADMIN_SESSION_KEY, '1');
        } catch {
          /* ignore */
        }
        setAuthed(true);
        setError(false);
      } else {
        setError(true);
      }
    },
    [password]
  );

  const logout = useCallback(() => {
    try {
      sessionStorage.removeItem(CUP_ADMIN_SESSION_KEY);
    } catch {
      /* ignore */
    }
    setAuthed(false);
    setPassword('');
    setError(false);
  }, []);

  if (!authed) {
    return (
      <div className="cup-scores-page cup-data-admin-gate" data-theme="dark">
        <main className="cup-scores-main cup-data-admin-gate__main">
          <header className="cup-scores-hero cup-data-admin-gate__hero">
            <h1>{L.adminGateTitle}</h1>
            <p className="cup-scores-hero__lead">{L.adminGateLead}</p>
          </header>
          <section className="cup-scores-card cup-data-admin-gate__card">
            <form className="cup-data-admin-form" onSubmit={onSubmit} autoComplete="off">
              <label className="cup-data-admin-form__label" htmlFor="cup-admin-pw">
                {L.adminPasswordLabel}
              </label>
              <input
                id="cup-admin-pw"
                name="cup-admin-password"
                type="password"
                autoComplete="new-password"
                className="cup-data-admin-form__input"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError(false);
                }}
              />
              {error ? <p className="cup-data-admin-form__error">{L.adminError}</p> : null}
              <button type="submit" className="cup-scores-linkbtn cup-data-admin-form__btn">
                {L.adminSubmit}
              </button>
            </form>
          </section>
        </main>
      </div>
    );
  }

  return <CupScores editable onAdminLogout={logout} />;
};

export default CupDataAdmin;
